import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { useStyles } from './style'
import { useTenant } from '@emerald-works-nova/auth'
import { Box } from '@mui/material'
import AuthLayout from '../../components/auth/auth-layout'
import TenantLogo from '../../components/tenant-logo'
import Pending from './components/pending'
import Expired from './components/expired'
import Invalid from './components/invalid'
import Verified from './components/verified'
import Error from './components/error'
import Auth from '@aws-amplify/auth'

const STATUSES = {
  PENDING: 'pending',
  VERIFIED: 'verified',
  INVALID: 'invalid',
  EXPIRED: 'expired',
  ERROR: 'error'
}

const VerifyEmailPage = () => {
  const classes = useStyles()
  const tenant = useTenant()

  const { username, code } = useParams()
  const [status, setStatus] = useState(STATUSES.PENDING)

  const verifyUrl = window.location.href.match(/\/\/(?<base>.+?)\//).groups.base

  const confirmUser = useCallback(async () => {
    try {
      await Auth.confirmSignUp(username, code)
      setStatus(STATUSES.VERIFIED)
    } catch (err) {
      console.log(err)
      if (err.message.includes('Current status is CONFIRMED')) {
        setStatus(STATUSES.VERIFIED)
      } else if (
        [
          'CodeMismatchException',
          'UserNotFoundException',
          'InvalidParameterException',
          'UserLambdaValidationException'
        ].includes(err.name)
      ) {
        setStatus(STATUSES.INVALID)
      } else if (err.name === 'ExpiredCodeException') {
        setStatus(STATUSES.EXPIRED)
      } else {
        setStatus(STATUSES.ERROR)
      }
    }
  }, [code, username])

  useEffect(() => {
    confirmUser()
  }, [confirmUser])

  const content = useMemo(() => {
    const components = {
      [STATUSES.PENDING]: <Pending />,
      [STATUSES.VERIFIED]: <Verified />,
      [STATUSES.INVALID]: <Invalid />,
      [STATUSES.EXPIRED]: <Expired verifyUrl={verifyUrl} username={username} />
    }

    return status in components ? components[status] : <Error />
  }, [status, username, verifyUrl])

  const logo = tenant.isPublicTenant ? 'mt-club' : 'mt-business'

  return (
    <AuthLayout>
      <Box className={classes.container}>
        <TenantLogo tenant={tenant} mtLogo={logo} height={75} />
        {content}
      </Box>
    </AuthLayout>
  )
}

export {
  VerifyEmailPage as Component
}
